export default __webpack_public_path__ + "static/media/cateogory-icon.1d8576e9.svg";